<template>
  <!-- v-for="(item, key) in quizList"
    :key="key"
    :data-type="item.type"
    :data-odds="item.odds"
    :data-choosenum="item.choose_num" -->
  <div
    class="quizCard"
    :class="info.stype === 1 ? 'card-allTeams' : 'card-normal'"
    :data-type="info.type"
    :data-odds="info.odds"
    :data-choosenum="info.choose_num"
  >
    <div class="header">
      <!-- <div class="left">{{ info.title }}</div> -->
      <div class="right">
        <div v-if="$lg(info, 'answers', []).length === 0" class="question">
          <img class="title-icon" v-if="info.stype === 1" src="https://website.xdcdn.net/module/sausage-match/images/quiz/iconQuiz.svg" :alt="title" />
          <div class="label-box">
            <div class="label-shadow">{{ title }}</div>
            <div class="label-text">{{ title }}</div>
          </div>
        </div>
        <div v-else-if="$lg(info, 'answers', []).length === 1" class="answer">
          <div class="label-box">
            <span class="label-shadow">竞猜结果：{{ $lg(info, "answers")[0]["answer"] }}</span>
            <span class="label-text">竞猜结果：{{ $lg(info, "answers")[0]["answer"] }}</span>
          </div>
        </div>
        <div
          v-else-if="$lg(info, 'answers', []).length >= 2"
          class="answer-btn"
          @click="handleResult(info)"
        >
          <div class="label-box">
            <span class="label-shadow">查看结果</span>
            <span class="label-text">查看结果</span>
          </div>
        </div>
        
        <div class="finish" v-else>
<!--          <i></i>-->
<!--          <div class="label-box">-->
<!--            <span class="label-shadow">开始时间: {{ info.startAt | time }}</span>-->
<!--            <span class="label-text">开始时间: {{ info.startAt | time }}</span>-->
<!--          </div>-->
<!--          <div class="label-box">-->
<!--            <span class="label-shadow">结束时间: {{ info.endAt | time }}</span>-->
<!--            <span class="label-text">结束时间: {{ info.endAt | time }}</span>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <div class="content">
      <slot></slot>
    </div>
    <Prompt :ref="`prompt${info.id}`"></Prompt>
  </div>
</template>

<script>
import Prompt from "@/components/prompt";

export default {
  inject: ['promptListen', 'handleResult'],
  components: { Prompt },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    title() {
      return this.info.title || '赛程竞猜'
    },
    prompt() {
      return this.promptListen();
    }
  },
  mounted() {
    // console.log('object111',this.info.id);
  },
  watch: {
   
    prompt(newVal) {
      if(newVal.id && newVal.msg) {
        this.$refs[newVal.id]?.setMsg(newVal.msg);
      }
      // 这里会打印出所以的msg信息
      // const { id, msg } = newVal;
      // console.log('newVal', this.$refs);
      // if (id && msg) {
      //   Object.keys(this.$refs).forEach(key => {
      //     if (key.startsWith('prompt')) {
      //       const ref = this.$refs[key];
      //       if (ref && typeof ref.setMsg === 'function') {
      //         ref.setMsg(msg);
      //       }
      //     }
      //   });
      // }
    }
  },
  filters: {
    time: (val) => {
      let dateZh = ["日", "一", "二", "三", "四", "五", "六"];
      let date = new Date(val);
      // 月/日
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let day = date.getDate();
      day = day < 10 ? "0" + day : day;
      // 小时/分钟
      let hour = date.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let min = date.getMinutes();
      min = min < 10 ? "0" + min : min;

      // return `${month}/${day}(周${dateZh[date.getDay()]}) ${hour}:${min} 截止`;
      return ` ${hour}:${min} `;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/quiz/layout/cardContainer.scss";
</style>